import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  baseUrl = environment.baseUrl;
  constructor(private http: HttpClient, private auth: AuthService) { }

  updateProfile(body: any) {
    let headers = new HttpHeaders();
    headers = headers.set('content-type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.auth.getToken());
    return this.http.post(`${this.baseUrl}v1/user/profile/`, body, { headers });
  }
  
  createAddresses(body: any) {
    let headers = new HttpHeaders();
    headers = headers.set('content-type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.auth.getToken());
    return this.http.post(`${this.baseUrl}v1/user/address/`, body, { headers });
  }
  
  getProfile() {
    let headers = new HttpHeaders();
    headers = headers.set('content-type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.auth.getToken());
    return this.http.get(`${this.baseUrl}v1/user/profile/`, { headers });
  }
  
  getAddresses() {
    let headers = new HttpHeaders();
    headers = headers.set('content-type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.auth.getToken());
    return this.http.get(`${this.baseUrl}v1/user/address/`, { headers });
  }
 
  getRewards() {
    let headers = new HttpHeaders();
    headers = headers.set('content-type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.auth.getToken());
    return this.http.get(`${this.baseUrl}v1/user/rewards/`, { headers });
  }

}
